import React from "react"
import { Router } from "@reach/router"

import Layout from "../../components/Layout"
import SEO from "../../components/seo"
import Header from "../../components/Header"
import List from './../../components/exam/List'
import Single from './../../components/exam/Single'
import TakenExam from './../../components/exam/TakenExam'
import TakenExams from './../../components/exam/TakenExams'
import Organizations from './../../components/exam/Organizations'
export default () => {

  return (
    <div className="slideInTop">
      <SEO title="آزمون ها" />
      <Header />
      <Layout className="p-32" route="tutorial">
        <Router basepath="/exam">
          <List path="/list/" />
          <Single path="/list/:id" />
          <TakenExams path="/taken-exams" />
          <TakenExam path="/taken-exams/:id" />
          <Organizations path="/organizations" />
        </Router>
      </Layout>
    </div>
  )
}